import { Injectable } from '@angular/core';
import { ListMetadata } from 'app/models/list-metadata.model';
import { Role } from 'app/models/role.model';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class RolesManagementService {

  baseUrl = "koncentro-auth";
  baseUrlRoles = "koncentro-auth/roles";
  baseUrlCompanies = "koncentro-auth/companies";
  baseUrlProfile = "koncentro-auth/profile";
  schemaUrl = "koncentro-auth/schema"
  cachedRoleFields:  Observable<Role>;;

  constructor(private http: HttpClientService) { }

    /**
   * Restituisce la lista dei Ruoli comuni
   */
     list(
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
    ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
      const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
      return this.http.getPaged(this.baseUrlRoles + '/getCommonRoles' + '?' + params.toString());
    }

    /**
     * Metodo che ritorna tutti i Ruoli comuni
     * @returns
     */
    getCommonRoles() {
      return this.http.get(this.baseUrlRoles + '/getCommonRoles');
    }

    /**
     * Metodo che ritorna i campi del DTO RoleDto
     * @returns
     */
    getRoleFields() {
      if (!this.cachedRoleFields) {
        this.cachedRoleFields = this.http.get(`${this.schemaUrl}/RoleDto`).pipe(
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
        )
      }
      return this.cachedRoleFields;
    }

    /**
     * Metodo per creare un ruolo comune
     * @param data
     */
    createCommonRole(data: any) {
      return this.http.post(this.baseUrlRoles + '/common-roles', data);
    }

    /**
     * Metodo per aggiornare un ruolo comune
     * @param data
     * @param descr
     */
    updateCommonRole(data: any, descr: string) {
      return this.http.put(this.baseUrlRoles + `/common-roles?descr=${descr}`, data);
    }

    /**
     * Restituisce le applications della company
     * @param companyId
     */
    getCompanyApplications(companyId: number) {
      return this.http.get(`${this.baseUrlCompanies}/company_applications/${companyId}`);
    }

    /**
     * Restituisce la lista dei profili
     */
    getProfiles() {
      return this.http.get(this.baseUrl + '/profile');
    }

    /**
     * Carica il profilo selezionato
     */
    loadProfile(profileId: number, roleDescription: string) {
      return this.http.get(`${this.baseUrlProfile}/load-profile/${profileId}?role_description=${roleDescription}`);
    }

    /**
     * Restituisce tutte le permission per un ruolo
     */
    showPermission(roleDescription: string) {
      return this.http.post(`${this.baseUrlRoles}/get-operations?role_description=${roleDescription}`, {});
    }

    /**
     * Salvataggio Ruolo
     */
    saveRole(data: any) {
      return this.http.post(`${this.baseUrlRoles}/set-operations`, data);
    }

    /**
     * Salvataggio Profilo
     */
    saveProfile(data: any) {
      return this.http.post(`${this.baseUrlProfile}`, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/roles-management/roles-management.service.ts